import React from 'react';

/**
 * Small grey rounded badge showing a source attribution (e.g. "Source: Ticketing Module").
 * Matches the visual in the screenshot: compact pill, muted grey background, small text.
 */
export default function ClientGroupSourceTag({ source }) {
    if (!source) return null;

    return (
        <span className="tw-inline-flex tw-items-center tw-px-2 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-medium tw-bg-gray-100 tw-text-charcoal-50 tw-whitespace-nowrap">
            {$t('Source: {{source}}', { source })}
        </span>
    );
}
